import { styles } from "./styles";

export interface ILayoutCompleteProps {
  children: React.ReactNode;
}

const LayoutComplete = ({ children }: ILayoutCompleteProps) => {
  const { classes } = styles();

  return (
    <div className={classes.mainContent}>
      {children}
    </div>
  );
};

export default LayoutComplete;
